// extracted by mini-css-extract-plugin
export var icon = "_e-1";
export var subtext = "_e-0";